<template class="full-height">
  <div
    class="coupon-category-app-container"
    style="position: relative; height: 100%; padding: 15px"
  >
    <!-- 圖表元件 柱狀圖-->
    <el-dialog
      v-if="chartsData && chartsData.length > 0"
      class="abow_dialog"
      append-to-body
      modal-append-to-body
      v-loading="listLoading"
      :visible.sync="dialogSatisfactionChatAnalysisVisible"
      width="95%"
      top="1%"
    >
      <!-- 自訂 Header 區域 -->
      <template #title>
        <div class="dialog-header-container">
          <span class="el-dialog__title">
            {{ `${currentSatisfactionAnalysis.title} 滿意度圖表分析(百分比)` }}
          </span>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-download"
            class="download-pdf-btn"
            @click="exportAnalysisHistogramCahtsToPDF"
          >
            下載PDF報告
          </el-button>
        </div>
      </template>

      <div ref="analysisHistogramCahtsRef">
        <template v-for="(chartData, index) in chartsData">
          <div :key="index">
            <analysis-histogram-caht
              :page="chartData.pageNumber"
              :legendData="chartData.legendData"
              :xAxisData="chartData.xAxisData"
              :seriesData="chartData.seriesData"
            ></analysis-histogram-caht>
          </div>
        </template>

        <template>
          <div style="margin-top: 20px">
            <analysis-bar-caht :satisfactionAnalysis="satisfactionAnalysis"></analysis-bar-caht>
          </div>
        </template>
      </div>
    </el-dialog>

    <!-- 表格元件 -->
    <el-dialog
      v-if="currentSatisfactionAnalysis"
      class="abow_dialog"
      append-to-body
      modal-append-to-body
      v-loading="listLoading"
      :visible.sync="dialogSatisfactionAnalysisVisible"
      :width="currentSatisfactionAnalysis.options.length <= 3 ? '60%' : '85%'"
      top="1%"
    >
      <!-- 自訂 Header 區域 -->
      <template #title>
        <div class="dialog-header-container">
          <span class="el-dialog__title">
            {{ `${currentSatisfactionAnalysis.title} 滿意度表格分析` }}
          </span>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-download"
            class="download-pdf-btn"
            @click="exportAnalysisTableToPDF"
          >
            下載PDF報告
          </el-button>
        </div>
      </template>

      <analysis-table
        ref="analysisTableRef"
        :currentSatisfactionAnalysis="currentSatisfactionAnalysis"
      ></analysis-table>
    </el-dialog>

    <!-- 答題統計 -->
    <el-dialog
      v-if="opinionSurveyPdfTopics.length > 0"
      class="abow_dialog"
      id="ansPdfModel"
      append-to-body
      v-loading="dialogLoading"
      :title="'意見調查表填寫總覽'"
      :visible.sync="dialogSurveyUserAnsStatisticsVisible"
      width="60%"
      top="1%"
      data-role="drag-drop-container"
    >
      <div id="pdfCatch" ref="capture">
        <el-alert
          title="分數說明，非常滿意:5分，滿意:4分，普通：3分，不太滿意:2分，非常不滿意：1分
              (滿意度計算公式：個人答題總分除以選項類型題數)"
          type="warning"
          effect="dark"
          :closable="false"
          style="color: #4b4b4b; margin-bottom: 10px"
        ></el-alert>
        <el-descriptions
          :labelStyle="{ 'text-align': 'left', 'font-size': '12px' }"
          :contentStyle="{ 'text-align': 'center' }"
          v-if="opinionSurveyPdfTopics && opinionSurveyPdfTopics.length > 0"
          class="margin-top"
          title=""
          :column="2"
          :size="'medium'"
          border
          style="margin: 5px 0px; border: 2px solid #ccc"
        >
          <!-- <template slot="extra">
          <el-button type="success" size="small">下載PDF</el-button>
        </template> -->

          <template v-for="(d, di) in opinionSurveyPdfTopics">
            <el-descriptions-item :key="di">
              <template slot="label">
                <i class="el-icon-user"></i>
                {{ d.title }}(數量)
              </template>
              <el-tag size="small">
                <count-to
                  :start-val="0"
                  :end-val="d.users.length"
                  :duration="4600"
                  class="card-panel-num"
                />/{{ d.userCount }}</el-tag
              >
            </el-descriptions-item>
            <el-descriptions-item :key="di">
              <template slot="label">
                <i class="el-icon-tickets"></i>
                {{ d.title }}(整體滿意度)
              </template>
              <el-tag size="small"> {{ d.totalSatisfactionPoint }}</el-tag>
            </el-descriptions-item>
            <!-- <el-descriptions-item :key="di">
              <template slot="label">
                <i class="el-icon-tickets"></i>
                {{ d.title }}(分數)
              </template>
              <el-tag size="small">
                <count-to
                  :start-val="0"
                  :end-val="d.point"
                  :duration="4600"
                  class="card-panel-num"
                />/{{ d.totalPoint }}</el-tag
              >
            </el-descriptions-item> -->
          </template>

          <!-- <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              分數說明
            </template>
            <el-tag size="small">
              非常滿意:5分，滿意:4分，普通：3分，不太滿意:2分，非常不滿意：1分
              (滿意度計算公式：個人答題總分除以選項類型題數。)</el-tag
            >
          </el-descriptions-item> -->

          <!-- <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-download"></i>
              下載PDF
            </template>
            <el-button
              :loading="pdfButtonLoading"
              style="width: 50%"
              type="success"
              @click="getPdf(d.travelID)"
              >下載</el-button
            >
          </el-descriptions-item> -->
        </el-descriptions>

        <el-scrollbar class="page-component__scroll">
          <template v-for="(item, index) in opinionSurveyPdfTopics">
            <el-alert
              v-if="item.users.length"
              close="kind-desc"
              :closable="false"
              :type="item.kind == 2 ? 'warning' : 'success'"
              effect="dark"
              :key="'l1_' + index"
            >
              <template slot="title">
                <div>{{ item.title }}</div>
              </template>
            </el-alert>
            <template v-for="(user, tindx) in item.users">
              <div
                style="
                  border: 5px solid #ccc;
                  padding: 20px 20px 0px;
                  height: 100%;
                  margin: 5px;
                  border-radius: 20px;
                "
                :key="'l2_' + tindx + index"
              >
                <el-alert
                  close="kind-desc"
                  type="success"
                  style="margin: 5px 0px; font-size: 14px"
                  :description="`填寫時間：${user.replyDate}`"
                  show-icon
                  :closable="false"
                >
                  <template slot="title">
                    <div>
                      {{ tindx + 1 }}、【{{ user.title }}】{{ user.userName }} ({{
                        '分數：' + user.point
                      }}，{{ '滿意度：' + user.satisfactionPoint }})
                    </div>
                  </template>
                </el-alert>

                <!-- <el-tag style="position: absolute; top: 0; left: 0">
              <count-to
                :start-val="0"
                :end-val="user.point"
                :duration="4600"
                class="card-panel-num"
              />/ {{ user.totalPoint }}</el-tag
            > -->

                <!-- <el-input
                  placeholder="請輸入表單標題"
                  disabled
                  v-model="user.title"
                >
                  <template slot="prepend">表單標題</template>
                </el-input> -->
                <el-form :inline="false">
                  <template v-for="(item, index) in user.topicList">
                    <el-form-item :key="'l3_' + index">
                      <template>
                        <el-tag v-if="item.required" type="info" size="mini">必填</el-tag>
                        <el-tag v-else type="info" size="mini">非必填</el-tag>
                        {{ index + 1 }}、
                        <span style="font-size: 12px; color: chocolate">{{
                          item.topicType == 1 ? '單選題' : '簡答題'
                        }}</span>
                        <el-switch
                          :disabled="item.hasAns"
                          v-if="!item.isDefault"
                          style="margin-left: 5px"
                          v-model="item.required"
                          active-text="必填"
                          inactive-text="非必填"
                        >
                        </el-switch>

                        <el-row>
                          <el-col :span="12">
                            <el-input
                              :disabled="item.isDefault || item.hasAns"
                              v-model="item.topicDescription"
                            ></el-input
                          ></el-col>
                        </el-row>
                        <!-- <el-input
                          :disabled="item.isDefault || item.hasAns"
                          size="mini"
                          v-model="item.topicDescription"
                        ></el-input>

                        <el-select
                          v-model="groupOptions"
                          style="margin-right: 5px"
                        >
                          <el-option
                            v-for="(item, index) in userKinds"
                            :label="item.val"
                            :key="index"
                            :value="item.key"
                          >
                          </el-option>
                        </el-select> -->

                        <template v-if="item.topicType == 1">
                          <template v-if="item.topicCustomAnswer == 0">
                            <template v-for="(op, opIndex) in item.options">
                              <el-tag
                                v-if="op.isSelected"
                                style="
                                  margin: 3px;
                                  font-size: 16px;
                                  border: 1px solid #ffd643;
                                  background-origin: #fff4cb;
                                "
                                type="warning"
                                size="medium"
                                :key="opIndex"
                                >{{ op.optionDescription }}</el-tag
                              >
                              <el-tag
                                v-if="!op.isSelected"
                                style="margin: 3px"
                                type="info"
                                :key="opIndex"
                                >{{ op.optionDescription }}</el-tag
                              >
                            </template>
                          </template>
                        </template>
                        <template v-if="item.topicType == 2">
                          <div class="ans-text" style="margin-top: 5px">
                            <el-input disabled :value="item.ansText"></el-input>
                          </div>
                        </template>
                      </template>
                    </el-form-item>
                  </template>
                </el-form>
              </div>
            </template>
          </template>
        </el-scrollbar>

        <!-- <span slot="footer" class="dialog-footer">
        <el-button
          @click="dialogSurveyUserAnsStatisticsVisible = false"
          type="danger"
          >關 閉</el-button
        >
      </span> -->
      </div>
    </el-dialog>

    <el-dialog
      id="ansModel"
      append-to-body
      v-loading="dialogLoading"
      :title="opinionSurveyTopics.title"
      :visible.sync="dialogSurveyQueryUserAnsVisible"
      width="60%"
      style="height: 100%"
      top="1%"
      data-role="drag-drop-container"
    >
      <div style="padding: 20px; padding-bottom: 0; height: 100%">
        <el-alert
          :title="ansSurveyTopics.userName"
          type="success"
          style="margin: 5px"
          :description="`填寫時間：${ansSurveyTopics.replyDate}`"
          show-icon
          :closable="false"
        >
        </el-alert>

        <el-tag style="position: absolute; top: 0; left: 0">
          <count-to
            :start-val="0"
            :end-val="ansSurveyTopics.point"
            :duration="4600"
            class="card-panel-num"
          />/ {{ ansSurveyTopics.totalPoint }}</el-tag
        >

        <el-input placeholder="請輸入表單標題" disabled v-model="ansSurveyTopics.title">
          <template slot="prepend">表單標題</template>
        </el-input>
        <el-form :inline="false">
          <template v-for="(item, index) in ansSurveyTopics.topicList">
            <el-form-item :key="index">
              <template>
                <el-tag v-if="item.required" type="info" size="mini">必填</el-tag>
                <el-tag v-else type="info" size="mini">非必填</el-tag>
                {{ index + 1 }}，
                <span style="font-size: 12px; color: chocolate">{{
                  item.topicType == 1 ? '單選題' : '簡答題'
                }}</span>
                <el-switch
                  :disabled="item.hasAns"
                  v-if="!item.isDefault"
                  style="margin-left: 5px"
                  v-model="item.required"
                  active-text="必填"
                  inactive-text="非必填"
                >
                </el-switch>

                <el-input
                  :disabled="item.isDefault || item.hasAns"
                  size="mini"
                  v-model="item.topicDescription"
                ></el-input>
                <template v-if="item.topicType == 1">
                  <template v-if="item.topicCustomAnswer == 0">
                    <template v-for="(op, opIndex) in item.options">
                      <el-tag
                        v-if="op.isSelected"
                        style="margin: 3px; font-size: 16px; border: 1px solid blue"
                        type="success"
                        size="medium"
                        :key="opIndex"
                        >{{ op.optionDescription }}</el-tag
                      >
                      <el-tag
                        size="mini"
                        v-if="!op.isSelected"
                        style="margin: 3px"
                        type="info"
                        :key="opIndex"
                        >{{ op.optionDescription }}</el-tag
                      >
                    </template>
                  </template>
                </template>
                <template v-if="item.topicType == 2">
                  <div class="ans-text">
                    <el-input disabled :value="item.ansText"></el-input>
                  </div>
                </template>
              </template>
            </el-form-item>
          </template>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSurveyQueryUserAnsVisible = false" type="danger">關 閉</el-button>
      </span>
    </el-dialog>

    <!-- 調查表維護 -->
    <el-dialog
      append-to-body
      v-loading="dialogLoading"
      :title="opinionSurveyTopics.title"
      :visible.sync="dialogSurveyQueryTopicVisible"
      width="60%"
      style="height: 100%"
      top="1%"
      id="source-container"
      data-role="drag-drop-container"
    >
      <div style="padding: 20px; padding-bottom: 0; height: 100%">
        <!-- <el-input
          placeholder="請輸入表單標題"
          v-model="opinionSurveyTopics.title"
        >
          <template slot="prepend">表單標題</template>
        </el-input> -->

        <el-alert type="warning" :closable="false" v-if="opinionSurveyTopics.agencyCode">
          <el-form :inline="true">
            <el-form-item label="表單標題">
              <el-input
                v-model="opinionSurveyTopics.title"
                :placeholder="'請輸入表單標題'"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-form
            v-if="!opinionSurveyTopics.isSysDefault || opinionSurveyTopics.travelID == 0"
            :inline="true"
          >
            <el-form-item
              label="表單類型"
              v-if="!opinionSurveyTopics.isSysDefault"
              style="display: flex; align-items: center"
            >
              <div style="display: flex; align-items: center">
                <el-select
                  v-model="opinionSurveyTopics.kind"
                  style="margin-right: 5px"
                  @change="handleKindChange"
                >
                  <el-option
                    v-for="(item, index) in userKinds"
                    :label="item.name"
                    :key="index"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <div style="padding-top: 5px" v-if="opinionSurveyTopics.travelID != 0">
                  <el-checkbox-group
                    v-show="opinionSurveyTopics.kind == 1"
                    v-model="travelDefaultSelected"
                    style="padding: 5px 15px"
                  >
                    <el-checkbox
                      v-for="option in travelDefaultOptions"
                      :key="option.name"
                      :label="option.value"
                    >
                      {{ option.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="預設" v-if="opinionSurveyTopics.travelID == 0">
              <el-switch
                v-model="opinionSurveyTopics.isDefault"
                active-text="設為預設"
                :active-value="true"
                :inactive-value="false"
                inactive-text=""
              >
              </el-switch>
            </el-form-item>
          </el-form>
          <!-- <el-form-item
              style="
                float: right;
                margin: 0px !important;
                padding: 0px !important;
                right: ;
                position: relative;
                right: -45px;
              "
            >
              <div class="new-topic-control" draggable="true" id="drag-source">
                <el-form v-model="newTopicData" :inline="true">
                  <el-form-item label="題目文字">
                    <el-input
                      v-model="newTopicData.topicDescription"
                      size="mini"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="必填">
                    <el-switch
                      v-model="newTopicData.required"
                      active-text="必填"
                      inactive-text="非必填"
                    >
                    </el-switch>
                  </el-form-item>

                  <el-form-item label="題目類型">
                    <el-select
                      style="width: 100px"
                      v-model="newTopicData.newTopicOption"
                      placeholder="請選擇"
                      size="mini"
                    >
                      <el-option
                        v-for="item in topicTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    ><el-button type="success" size="mini" @click="addTopic"
                      >新增題目</el-button
                    ></el-form-item
                  >
                </el-form>
              </div>
            </el-form-item> -->
          <el-form v-model="newTopicData" :inline="true">
            <el-form-item label="題目文字">
              <el-input v-model="newTopicData.topicDescription"></el-input>
            </el-form-item>

            <el-form-item label="是否必填">
              <el-switch v-model="newTopicData.required" active-text="必填" inactive-text="非必填">
              </el-switch>
            </el-form-item>

            <el-form-item label="題目類型">
              <el-select
                style="width: 100px"
                v-model="newTopicData.newTopicOption"
                placeholder="請選擇"
              >
                <el-option
                  v-for="item in topicTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="題組類型">
              <el-select v-model="defaultTopicGroup" style="margin-left: 5px">
                <el-option
                  v-for="(item, index) in groupOptions"
                  :label="item.val"
                  :key="index"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-button
              type="warning"
              @click="addTopic"
              circle
              icon="el-icon-plus"
              :disabled="listLoading"
            ></el-button>
          </el-form>
        </el-alert>

        <el-form :inline="false" style="max-height: calc(100vh - 350px); overflow: auto">
          <template v-for="(item, index) in opinionSurveyTopics.topicList">
            <el-form-item :key="index">
              <template>
                <el-tag v-if="item.required" type="danger" size="mini">必填</el-tag>
                <el-tag v-else type="info" size="mini">非必填</el-tag>
                {{ index + 1 }}、
                <span style="font-size: 12px; color: chocolate">{{
                  item.topicType == 1 ? '單選題' : '簡答題'
                }}</span>
                <el-switch
                  :disabled="item.hasAns"
                  v-if="!item.isDefault"
                  style="margin-left: 5px"
                  v-model="item.required"
                  active-text="必填"
                  inactive-text="非必填"
                >
                </el-switch>

                <el-select
                  v-model="item.topicGroup"
                  style="margin-left: 5px"
                  :disabled="item.isDefault || item.hasAns"
                >
                  <el-option
                    v-for="(item, index) in groupOptions"
                    :label="item.val"
                    :key="index"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>

                <el-button
                  :disabled="item.hasAns"
                  style="margin-left: 5px"
                  type="danger"
                  size="mini"
                  @click="deleteTopic(index)"
                  v-if="!item.isDefault"
                  >刪除</el-button
                >

                <el-input
                  :disabled="item.isDefault || item.hasAns"
                  size="mini"
                  v-model="item.topicDescription"
                ></el-input>
                <template v-if="item.topicType == 1">
                  <template v-if="item.topicCustomAnswer == 0">
                    <template v-for="(op, opIndex) in item.options">
                      <el-tag style="margin: 3px" type="info" :key="opIndex">{{
                        op.optionDescription
                      }}</el-tag>
                    </template>
                  </template>
                </template>

                <template v-if="!item.isDefault && item.hasAns">
                  <el-tag size="mini" type="danger">此題已有回覆，無法做任何異動調整</el-tag>
                </template>
              </template>
            </el-form-item>
          </template>
          <template v-for="(item, index) in travelDefaultSelected">
            <el-form-item :key="`travelDefaultSelected_${index}`">
              <template>
                <el-tag v-if="item.required" type="danger" size="mini">必填</el-tag>
                <el-tag v-else type="info" size="mini">非必填</el-tag>
                {{ opinionSurveyTopics.topicList.length + (index + 1) }}、
                <span style="font-size: 12px; color: chocolate">{{
                  item.topicType == 1 ? '單選題' : '簡答題'
                }}</span>
                <el-switch
                  :disabled="item.hasAns"
                  v-if="!item.isDefault"
                  style="margin-left: 5px"
                  v-model="item.required"
                  active-text="必填"
                  inactive-text="非必填"
                >
                </el-switch>

                <el-select
                  v-model="item.topicGroup"
                  style="margin-left: 5px"
                  :disabled="item.isDefault || item.hasAns"
                >
                  <el-option
                    v-for="(item, index) in groupOptions"
                    :label="item.val"
                    :key="index"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>

                <el-button
                  :disabled="item.hasAns"
                  style="margin-left: 5px"
                  type="danger"
                  size="mini"
                  @click="deleteTopic(index)"
                  v-if="!item.isDefault"
                  >刪除</el-button
                >

                <el-input
                  :disabled="item.isDefault || item.hasAns"
                  size="mini"
                  v-model="item.topicDescription"
                ></el-input>
                <template v-if="item.topicType == 1">
                  <template v-if="item.topicCustomAnswer == 0">
                    <template v-for="(op, opIndex) in item.options">
                      <el-tag style="margin: 3px" type="info" :key="opIndex">{{
                        op.optionDescription
                      }}</el-tag>
                    </template>
                  </template>
                </template>

                <template v-if="!item.isDefault && item.hasAns">
                  <el-tag size="mini" type="danger">此題已有回覆，無法做任何異動調整</el-tag>
                </template>
              </template>
            </el-form-item>
          </template>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="saveTravelsOpinionSurveySetting" style="color: #4b4b4b"
          >儲 存</el-button
        >
        <el-button @click="dialogSurveyQueryTopicVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 維護與分析 -->
    <el-dialog
      @opened="getAgencySurveyQueries"
      append-to-body
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogSurveyQueryVisible"
      width="70%"
      style="height: 100%"
    >
      <el-card class="box-card maintainCard" style="height: 600px">
        <div style="position: relative; height: 100%" v-loading="listLoading">
          <el-form :inline="true" class="filter-form">
            <el-form-item label="選擇意見調查表">
              <el-select v-model="agencySurveyQueryID" clearable placeholder="請選擇意見調查表">
                <el-option
                  v-for="item in agencySurveyQueryOptions"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                  :disabled="item.selected"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-tooltip v-if="agencySurveyQueryID" content="建立至旅遊團" placement="top">
              <el-button
                v-if="agencySurveyQueryID"
                type="warning"
                @click="createSurveyQueryToTravel"
                circle
                icon="el-icon-plus"
                style="margin-top: 8px; margin-left: 5px"
                :disabled="listLoading"
              ></el-button>
            </el-tooltip>
            <el-button
              style="cursor: pointer; margin-top: 8px; margin-left: 5px"
              :loading="listLoading"
              type="success"
              icon="el-icon-refresh-left"
              circle
              @click="refresh(3)"
            ></el-button>
          </el-form>

          <el-alert
            title="問卷使用對象為旅客及領隊，各自限定僅能填寫一份，未手動更改將顯示系統預設問卷。"
            type="error"
            :closable="false"
            style="margin-bottom: 10px"
          >
          </el-alert>

          <el-table size="mini" :data="opinionSurveies" border style="width: 100%" height="75%">
            <el-table-column align="center" label="項次" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="title" label="意見調查表名稱" width="180" align="center">
            </el-table-column>

            <el-table-column align="center" label="使用對象" width="100">
              <template slot-scope="{ row }">
                <div>
                  <el-tag :type="row.kind == 1 ? 'success' : row.kind == 2 ? 'warning' : 'primary'"
                    >{{ row.kind == 1 ? '旅客' : row.kind == 2 ? '領隊' : '旅行社' }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="類型" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.isSysDefault" type="success" size="mini">系統建立</el-tag>
              </template>
            </el-table-column>

            <el-table-column align="center" label="維護" width="100">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="info"
                  @click="getTravelsOpinionSurveyTopic(scope.row.id)"
                  >維護</el-button
                >
              </template>
            </el-table-column>

            <el-table-column align="center" label="填寫名單" width="150">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="warning"
                  @click="confirmTravelsOpinionSurveyByOpinionSurveyID(scope.row.id)"
                  >填寫名單</el-button
                >
              </template>
            </el-table-column>

            <el-table-column align="center" label="App使用" width="200">
              <template slot-scope="{ row }">
                <div>
                  <el-switch
                    @change="settingShowToApp(row)"
                    v-model="row.showToApp"
                    active-text="設定為App使用"
                    :active-value="true"
                    :inactive-value="false"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                </div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="表格分析" width="150">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="getSatisfactionAnalysisDetails(scope.row)"
                  >表格分析</el-button
                >
              </template>
            </el-table-column>

            <el-table-column align="center" label="圖表分析" width="150">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="success"
                  @click="getSatisfactionAnalysisChat(scope.row)"
                  >圖表分析</el-button
                >
              </template>
            </el-table-column>

            <el-table-column align="center" label="建立時間" width="170">
              <template slot-scope="{ row }">
                <span>{{ row.buildDate }} </span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="刪除" width="100">
              <template slot-scope="{ row }">
                <el-button
                  v-if="!row.isSysDefault"
                  size="mini"
                  type="danger"
                  @click="deleteOpinionSurvery(row.id)"
                  >刪除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSurveyQueryVisible = false" type="danger">關 閉</el-button>
      </span>
    </el-dialog>

    <!-- 填寫名單 -->
    <el-dialog
      append-to-body
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="'填寫名單'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <div style="position: relative; height: 80%" v-loading="listLoading">
          <el-table size="mini" :data="travelersReply" border style="width: 100%" height="400">
            <el-table-column align="center" label="項次" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="userName" label="姓名" align="center"> </el-table-column>

            <el-table-column align="center" label="狀態" width="200">
              <template slot-scope="{ row }">
                <div>
                  <el-tag :type="row.isReply ? 'success' : 'danger'"
                    >{{ row.isReply ? '已填寫' : '未填寫' }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="填寫時間" width="200">
              <template slot-scope="{ row }">
                <span v-if="row.replyDate">{{ row.replyDate }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="查看" width="200">
              <template slot-scope="{ row }">
                <div v-if="row.isReply">
                  <el-button type="success" size="mini" @click="getAnReply(row)">查看 </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="danger">關 閉</el-button>
      </span>
    </el-dialog>

    <el-tabs type="border-card" v-model="currentTab" style="height: 100%; position: relative">
      <div style="position: absolute; right: 0%; top: 0; z-index: 99" v-show="device == 'mobile'">
        <el-button
          @click="showNotSatisfiedBoxCard = !showNotSatisfiedBoxCard"
          type="danger"
          size="small"
          :icon="showNotSatisfiedBoxCard ? 'el-icon-close' : 'el-icon-star-on'"
        ></el-button>
      </div>
      <el-tab-pane label="意見調查表" name="1">
        <div style="position: relative; display: flex; gap: 0 12px; width: 100%; height: 100%">
          <div
            style="min-width: 0; width: 100%"
            v-show="device != 'mobile' || (!showNotSatisfiedBoxCard && device == 'mobile')"
          >
            <el-form :inline="true" class="filter-form" @submit.native.prevent>
              <el-form-item label="查詢">
                <el-input
                  v-model="listQuery.qry"
                  placeholder="輸入團號/團名"
                  @keyup.enter.native="getAgencyTravelsAndOtherInformation"
                />
              </el-form-item>

              <el-button
                type="primary"
                @click="getAgencyTravelsAndOtherInformation"
                icon="el-icon-search"
                circle
                style="margin-top: 8px; margin-left: 5px"
                :disabled="listLoading"
              ></el-button>
              <el-button
                style="cursor: pointer"
                type="success"
                :loading="listLoading"
                circle
                icon="el-icon-refresh-left"
                @click="refresh(2)"
              ></el-button>

              <template
                v-if="
                  checkPermission([
                    'ITA-ADMIN',
                    'ITA-DEV',
                    'ITA-ADM-STAFF',
                    'ITA-SALES-ASSISTANT',
                    'ITA-BOSS',
                  ])
                "
              >
                <div style="line-height: 36px; color: green; text-align: right">
                  總平均分數/總填寫份數：<strong
                    >{{ averageAppSatisfactionPoint }}({{
                      averageAppSatisfactionPointCount
                    }})</strong
                  >
                </div>
              </template>
            </el-form>

            <div style="position: relative; height: 80%" v-loading="listLoading">
              <el-table size="mini" :data="list" border style="width: 100%" height="100%">
                <el-table-column align="center" label="項次" width="60" fixed="left">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="tourGroupNo" label="團號" width="180" align="center">
                </el-table-column>

                <el-table-column align="center" label="團名" width="400">
                  <template slot-scope="{ row }">
                    <span>{{ row.travelName }}</span>
                    <div>
                      <el-tag>
                        出發{{ `${row.beginDate} ${row.beginTime}` }} - 回程{{
                          `${row.endDate} ${row.endTime}`
                        }}
                      </el-tag>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column align="center" label="維護與分析" width="130">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      @click="getAgencyTravelsOpinionSurveies(scope.row.id)"
                      >維護與分析</el-button
                    >
                  </template>
                </el-table-column>

                <el-table-column align="center" label="答題統計" width="130">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="warning"
                      @click="getTravelsOpinionSurveyReplyAllDetails(scope.row.id)"
                      >答題統計</el-button
                    >
                  </template>
                </el-table-column>

                <el-table-column align="center" label="下載" width="130">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="success"
                      :loading="currentDlPdfIDs.includes(scope.row.id)"
                      @click="
                        getPdf(scope.row.id, `${scope.row.tourGroupNo}_${scope.row.travelName}`)
                      "
                      >下載PDF</el-button
                    >
                  </template>
                </el-table-column>

                <el-table-column align="center" label="下載" width="130">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="success"
                      :loading="currentDlExcelIDs.includes(scope.row.id)"
                      @click="
                        getExcel(scope.row.id, `${scope.row.tourGroupNo}_${scope.row.travelName}`)
                      "
                      >下載EXCEL</el-button
                    >
                  </template>
                </el-table-column>

                <!-- <template v-if="checkPermission(['ITA-ADMIN', 'ITA-DEV', 'ITA-ADM-STAFF', 'ITA-SALES-ASSISTANT', 'ITA-BOSS'])"> -->
                <el-table-column
                  prop="appSatisfactionPoint"
                  label="APP滿意度"
                  width="180"
                  align="center"
                >
                  <template slot-scope="scope">
                    <!-- <span style="color: red;"> -->
                    {{
                      scope.row.appSatisfactionPoint == '0(0)' ? '' : scope.row.appSatisfactionPoint
                    }}
                    <!-- </span> -->
                  </template>
                </el-table-column>
                <!-- </template> -->
              </el-table>

              <pagination
                v-show="total > 0"
                layout="prev, pager, next"
                :total="total"
                :page.sync="listQuery.page"
                :limit.sync="listQuery.limit"
                @pagination="getAgencyTravelsAndOtherInformation"
              />
            </div>
          </div>

          <div
            v-show="showNotSatisfiedBoxCard"
            style="
              width: 315px;
              flex-basis: 315px;
              flex-shrink: 0;
              height: 100%;
              max-height: 100%;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
              overflow-y: hidden;
            "
          >
            <!-- 意見調查滿意度 (不滿意的旅客) -->
            <div
              style="
                font-size: 16px;
                font-weight: bold;
                padding: 15px 8px;
                color: red;
                border-bottom: 1px solid #ddd;
              "
            >
              旅客填寫不滿意、非常不滿意
            </div>
            <div style="padding: 8px; height: 100%; max-height: 90%; overflow-y: auto">
              <not-satisfied-box-card :limit="50" :show-header="false" />
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="表單設計" name="2">
        <div class="full-height">
          <el-form :inline="true" class="filter-form" @submit.native.prevent>
            <!-- <el-form-item label="查 詢">
                <el-input
                  v-model="agencyListQuery.qry"
                  placeholder="輸入表單標題"
                  size="mini"
                />
              </el-form-item> -->
            <el-form-item label="查詢">
              <el-input
                v-model="agencyListQuery.qry"
                placeholder="輸入團號/團名"
                @keyup.enter.native="getAgencyOpinionSurvey"
              />
            </el-form-item>

            <el-button
              type="primary"
              @click="getAgencyOpinionSurvey"
              icon="el-icon-search"
              circle
              style="margin-top: 8px; margin-left: 5px"
              :disabled="listLoading"
            ></el-button>
            <el-button
              type="warning"
              @click="addData"
              circle
              icon="el-icon-plus"
              :disabled="listLoading"
            ></el-button>

            <el-button
              style="cursor: pointer"
              type="success"
              :loading="listLoading"
              circle
              icon="el-icon-refresh-left"
              @click="refresh(1)"
            ></el-button>
            <!-- <el-form-item>
                <el-button
                  type="primary"
                  @click="getAgencyOpinionSurvey"
                  size="mini"
                  >查 詢</el-button
                >
              </el-form-item> -->

            <!-- <el-form-item>
                <el-button type="success" @click="addData" size="mini"
                  >新增意見調查表</el-button
                >
              </el-form-item> -->

            <!-- <el-form-item>
                <el-button
                  style="cursor: pointer"
                  v-loading="listLoading"
                  type="success"
                  icon="el-icon-refresh-left"
                  circle
                  @click="refresh(1)"
                ></el-button>
              </el-form-item> -->
          </el-form>

          <div style="position: relative; height: 90%" v-loading="listLoading">
            <el-table
              size="mini"
              :data="agencyOpinionSurveies"
              border
              style="width: 100%"
              height="100%"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="title" label="意見調查表名稱" width="180" align="center">
              </el-table-column>

              <el-table-column align="center" label="意見調查表類型" width="130">
                <template slot-scope="{ row }">
                  <div>
                    <el-tag :type="row.kind == 1 ? 'success' : 'warning'"
                      >{{ row.kind == 1 ? '旅客' : '領隊' }}
                    </el-tag>
                  </div>
                </template>
              </el-table-column>

              <el-table-column align="center" label="預設" width="150">
                <template slot-scope="scope">
                  <el-switch
                    @change="triggerDefault(scope.row)"
                    v-model="scope.row.isDefault"
                    active-text="設為預設"
                    :active-value="true"
                    :inactive-value="false"
                    inactive-text=""
                  >
                  </el-switch>
                </template>
              </el-table-column>

              <!-- <el-table-column align="center" label="系統預設" width="150">
                  <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.isSysDefault"
                      type="success"
                      size="mini"
                      >系統建立</el-tag
                    >
                  </template>
                </el-table-column> -->

              <el-table-column align="center" label="意見調查表維護" width="150">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="info"
                    @click="getTravelsOpinionSurveyTopic(scope.row.id)"
                    >意見調查表維護</el-button
                  >
                </template>
              </el-table-column>
              <!--
                <el-table-column
                  align="center"
                  label="填寫旅客名單"
                  width="150"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="success"
                      @click="
                        confirmTravelsOpinionSurveyByOpinionSurveyID(
                          scope.row.id
                        )
                      "
                      >填寫旅客名單</el-button
                    >
                  </template>
                </el-table-column> -->

              <el-table-column align="center" label="建立時間" width="200">
                <template slot-scope="{ row }">
                  <div>
                    <el-tag type="info">{{ row.buildDate }} </el-tag>
                  </div>
                </template>
              </el-table-column>

              <el-table-column align="center" label="刪除" width="200">
                <template slot-scope="{ row }">
                  <div>
                    <el-button size="mini" type="danger" @click="deleteOpinionSurvery(row.id)"
                      >刪除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <pagination
              v-show="agencyTotal > 0"
              style="padding-top: 0"
              layout="prev, pager, next"
              :total="total"
              :page.sync="agencyListQuery.page"
              :limit.sync="agencyListQuery.limit"
              @pagination="getAgencyOpinionSurvey"
            />
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
// function dropInit(params) {
//   let dragSources = document.querySelectorAll('[draggable="true"]');
//   dragSources.forEach((dragSource) => {
//     dragSource.addEventListener("dragstart", dragStart);
//   });

//   function dragStart(e) {
//     e.dataTransfer.setData("text/plain", e.target.id);
//   }

//   let dropTargets = document.querySelectorAll(
//     '[data-role="drag-drop-container"] *'
//   );

//   console.log(dropTargets);
//   dropTargets.forEach((dropTarget) => {
//     dropTarget.addEventListener("drop", dropped);
//     dropTarget.addEventListener("dragenter", cancelDefault);
//     dropTarget.addEventListener("dragover", cancelDefault);
//   });
//   function dropped(e) {
//     cancelDefault(e);
//     let id = e.dataTransfer.getData("text/plain");
//     e.target.appendChild(document.querySelector("#" + id));
//   }

//   function cancelDefault(e) {
//     e.preventDefault();
//     e.stopPropagation();
//     return false;
//   }
// }
import CountTo from 'vue-count-to'
import request from '@/utils/request'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
// 滿意度分析，圖表元件
import AnalysisBarCaht from '../components/SatisfactionAnalysisBarChartComponent.vue'
import AnalysisHistogramCaht from '../components/SatisfactionAnalysisHistogramChartComponent.vue'
// 滿意度分析，表格元件
import AnalysisTable from '../components/SatisfactionAnalysisTableComponent.vue'
import NotSatisfiedBoxCard from '@/components/CardList/NotSatisfiedBoxCard'
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash-es'
import checkPermission from '@/utils/permission'

import {
  getAgencyTravelsOpinionSurveies,
  getAgencyTravelsAndOtherInformation,
  getAgencyOpinionSurvey,
  setAgencyOpinionSurveyDefault,
  getAgencyTravelOpinionSurveyOptions,
  createSurveyQueryToTravel,
  settingShowToApp,
  deleteOpinionSurvery,
} from '@/api/agency'

import {
  confirmTravelsOpinionSurveyByOpinionSurveyID,
  getTravelsOpinionSurveyReplyAllDetails,
  getTravelsOpinionSurveyReplyDetails,
  getTravelsOpinionSurveyTopic,
  saveTravelsOpinionSurveySetting,
  getTravelsOpinionSurveyPdfBeforeCheck,
  getQuestionnaireTopicGroupOptions,
  getSatisfactionAnalysis,
} from '@/api/travel'

import { MessageBox, Message } from 'element-ui'
import { parse } from 'path-to-regexp'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export default {
  name: 'AgencyOpinionSurvey',
  components: {
    Pagination,
    CountTo,
    AnalysisTable,
    AnalysisBarCaht,
    AnalysisHistogramCaht,
    NotSatisfiedBoxCard,
  },
  computed: {
    ...mapGetters(['device']),
  },
  async activated() {
    await this.refresh(1)
    await this.refresh(2)
  },
  watch: {
    'opinionSurveyTopics.kind': {
      deep: true,
      handler(val) {
        this.defaultTopicGroup = val
      },
    },
    async isExportLoading(newValue) {
      if (newValue) {
        try {
          await this.$store.dispatch('app/showDownloadLoading', true)
          await this.$store.dispatch('app/showDownloadLoadingText', '資料處理中，請稍後')
        } catch (error) {
          console.error('Loading 初始化失敗:', error)
          await this.$store.dispatch('app/showDownloadLoading', false)
        }
      } else {
        await this.$store.dispatch('app/showDownloadLoading', false)
      }
    },
  },
  data() {
    return {
      currentDlPdfIDs: [],
      currentDlExcelIDs: [],
      defaultTopicGroup: 1,
      chartsData: [],
      currentSatisfactionAnalysis: null,
      dialogSatisfactionAnalysisVisible: false,
      dialogSatisfactionChatAnalysisVisible: false,
      currentTab: '1',
      pdfButtonLoading: false,
      opinionSurveyPdfTopics: [],
      dialogSurveyUserAnsStatisticsVisible: false,
      questionnaireID: null,
      dialogSurveyQueryUserAnsVisible: false,
      travelID: null,
      newTopicData: {
        topicDescription: '',
        required: true,
        newTopicOption: 1,
        isDefault: false,
      },
      topicTypeOptions: [
        { label: '單選題', value: 1 },
        { label: '簡答題', value: 2 },
      ],
      dialogSurveyQueryVisible: false,
      dialogSurveyQueryTopicVisible: false,
      funcName: '意見調查表管理',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      travelersReply: [],
      agencyListQuery: {
        qry: '',
        kind: 3,
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      listOpinionSurveyQuery: {
        travelID: null,
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '+buildDate',
        kind: null,
      },
      agencyOpinionSurveies: [],
      opinionSurveies: [],
      opinionSurveyTopics: {},
      ansSurveyTopics: {},
      total: 0,
      agencyTotal: 0,
      list: [],
      onGetAgencySurveyQueriesLoading: false,
      agencySurveyQueryID: null,
      agencySurveyQueryOptions: [],
      userKinds: [
        { id: 1, name: '旅客' },
        { id: 2, name: '領隊' },
      ],
      groupOptions: [],
      showNotSatisfiedBoxCard: true,
      averageAppSatisfactionPoint: 0.0,
      averageAppSatisfactionPointCount: 0,
      travelDefaultSelected: [],
      travelDefaultOptions: [
        {
          name: '參團消息來源',
          value: {
            topicGroup: 1,
            hasAns: false,
            isDefault: true,
            required: true,
            topicCustomAnswer: 2,
            topicID: null,
            topicDescription: '您於何處得知參團消息',
            topicType: 2,
            sort: null,
            options: [],
          },
        },
        {
          name: '下次旅行國家',
          value: {
            topicGroup: 1,
            hasAns: false,
            isDefault: true,
            required: true,
            topicCustomAnswer: 1,
            topicID: null,
            topicDescription: '預計下次想前往旅遊的國家',
            topicType: 2,
            sort: null,
            options: [],
          },
        },
        {
          name: 'APP滿意度',
          value: {
            topicGroup: 1,
            hasAns: false,
            isDefault: true,
            required: true,
            topicCustomAnswer: 0,
            topicID: null,
            topicDescription: '此APP帶給您的使用體驗',
            topicType: 1,
            sort: null,
            options: [
              {
                optionID: null,
                optionDescription: '非常滿意',
                ansPoint: 5,
                sort: 1,
              },
              {
                optionID: null,
                optionDescription: '滿意',
                ansPoint: 4,
                sort: 2,
              },
              {
                optionID: null,
                optionDescription: '普通',
                ansPoint: 3,
                sort: 3,
              },
              {
                optionID: null,
                optionDescription: '不太滿意',
                ansPoint: 2,
                sort: 4,
              },
              {
                optionID: null,
                optionDescription: '非常不滿意',
                ansPoint: 1,
                sort: 5,
              },
            ],
          },
        },
      ],
      isExportLoading: false,
    }
  },
  async created() {
    // await this.deleteOpinionSurvery(36);
    await this.getQuestionnaireTopicGroupOptions()
    await this.getAgencyOpinionSurvey()
    await this.getAgencyTravelsAndOtherInformation()
  },
  methods: {
    checkPermission,
    async refresh(type) {
      switch (type) {
        case 1:
          this.agencyListQuery = {
            qry: '',
            kind: 3,
            date: '',
            status: null,
            page: 1,
            limit: 20,
            sort: '-id',
          }

          await this.getAgencyOpinionSurvey()
          break
        case 2:
          this.listQuery = {
            qry: '',
            date: '',
            status: null,
            page: 1,
            limit: 20,
            sort: '-id',
          }
          await this.getAgencyTravelsAndOtherInformation()
          break
        case 3:
          await this.getAgencyTravelsOpinionSurveies(this.listOpinionSurveyQuery.travelID)
          break
        default:
          break
      }
    },
    async getSatisfactionAnalysisDetails(row) {
      //滿意度分析 表格
      let formID = row.id
      this.travelID = row.travelID
      this.listLoading = true

      let resp = await getSatisfactionAnalysis({
        travelID: this.travelID,
        formID,
      })

      if (resp.data && resp.data.length > 0) {
        this.currentSatisfactionAnalysis = resp.data[0]
        this.dialogSatisfactionAnalysisVisible = true
      } else {
        alert('尚無資料')
      }
      this.listLoading = false
    },
    async getSatisfactionAnalysisChat(row) {
      //滿意度分析 圖表
      let formID = row.id
      this.travelID = row.travelID
      this.listLoading = true
      let resp = await getSatisfactionAnalysis({
        travelID: this.travelID,
        formID,
      })

      if (resp.data && resp.data.length > 0) {
        this.currentSatisfactionAnalysis = resp.data[0]
        this.checkChartData()
        this.dialogSatisfactionChatAnalysisVisible = true
      } else {
        alert('尚無資料')
      }
      this.listLoading = false
    },
    async checkChartData() {
      if (!this.currentSatisfactionAnalysis) return
      this.chartsData = []
      const legendData = this.currentSatisfactionAnalysis.options.map(
        ({ optionDescription }) => optionDescription
      )

      const topicSource = this.currentSatisfactionAnalysis.topicList
      //滿意度
      this.satisfactionAnalysis = topicSource.reduce(
        (obj, { topicDescription, satisfactionAnalysis }) => {
          obj.topicDescription.push(topicDescription)
          obj.satisfactionAnalysis.push(satisfactionAnalysis)
          return obj
        },
        { topicDescription: [], satisfactionAnalysis: [] }
      )

      const topcis = topicSource.map(({ topicID, topicDescription }) => ({
        topicID,
        desc: topicDescription,
      }))

      //題組分頁處理
      const { body } = document
      const rect = body.getBoundingClientRect()
      const isMobile = rect.width - 1 < 992
      const paginatedTopics = await this.paginate(topcis, isMobile ? 1 : 2)

      this.chartsData = paginatedTopics.map(({ page, pageItems }) => {
        const xAxisData = pageItems.map(({ desc }) => desc)
        const seriesData = legendData.map(title => {
          const temp = this.formatDataAsChart(title)
          pageItems.forEach(({ topicID }) => {
            temp.data.push(this.findOptionPercentage(topicSource, topicID, title))
          })
          return temp
        })
        console.log('seriesData', seriesData)
        return { pageNumber: page, xAxisData, seriesData, legendData }
      })
      // this.chartsData = [this.chartsData[0]];
    },
    findOptionPercentage(topcis, topicID, title) {
      let percentage = 0
      let find = topcis.filter(f => {
        return f.topicID == topicID
      })
      if (find && find.length > 0) {
        let topic = find[0]

        let findOption = topic.options.filter(f => {
          return f.optionDescription == title
        })

        if (findOption && findOption.length > 0) {
          let option = findOption[0]
          percentage = option.percentage
        }
      }
      return percentage
    },
    paginate(array, pageSize) {
      //圖表呈現五個題組，分頁處理，
      //不知為啥，不用非同步的話陣列會不完全。所以用promise包。回傳一個promise物件
      return new Promise(resolve => {
        const totalPages = Math.ceil(array.length / pageSize)
        const paginatedItems = []
        for (let page = 1; page <= totalPages; page++) {
          const startIndex = (page - 1) * pageSize
          const endIndex = page * pageSize
          const pageItems = array.slice(startIndex, endIndex)
          paginatedItems.push({ page: page, pageItems })
        }
        resolve(paginatedItems)
      })
    },
    formatDataAsChart(name) {
      var color = ''
      switch (name) {
        case '非常滿意':
        case '好':
          color = '#2F5CFF'
          break
        case '滿意':
          color = '#44D600'
          break
        case '普通':
          color = '#FFC107'
          break
        case '不太滿意':
          color = '#FF9100'
          break
        case '非常不滿意':
        case '不好':
          color = '#FF3B3B'
          break
      }
      return {
        name: name,
        type: 'bar',
        label: null,
        emphasis: {
          focus: 'series',
        },
        data: [],
        color: color,
      }
    },
    async getQuestionnaireTopicGroupOptions() {
      let resp = await getQuestionnaireTopicGroupOptions()
      this.groupOptions = resp.data
    },
    async settingShowToApp(row) {
      this.listLoading = true
      let payload = {
        qID: row.id,
        travelID: row.travelID,
      }
      let resp = await settingShowToApp(payload)
      await this.getAgencyTravelsOpinionSurveies(row.travelID)
      this.listLoading = false
    },
    async deleteOpinionSurvery(id, row) {
      if (!confirm(`確定刪除此意見調查?\n按下確定後將會刪除所有題目，選項以及回覆結果。`)) {
        return
      }
      this.listLoading = true

      let resp = await deleteOpinionSurvery({ id })

      await this.getAgencyOpinionSurvey()
      await this.getAgencyTravelsAndOtherInformation()

      let res = await getAgencyTravelsOpinionSurveies(this.listOpinionSurveyQuery)
      this.opinionSurveies = res.data.data

      this.listLoading = false

      Message({
        message: '意見調查表刪除完成',
        type: 'success',
        duration: 5 * 1000,
      })
      this.listLoading = false
    },
    async createSurveyQueryToTravel() {
      if (confirm(`確定將此意見調查表複製一份至旅遊團使用?`)) {
        let vm = this

        let showToApp = confirm(`是否設定App使用此意見調查表?`)

        let payload = {
          qID: vm.agencySurveyQueryID,
          travelID: vm.listOpinionSurveyQuery.travelID,
          showToApp,
        }
        this.listLoading = true

        let resp = await createSurveyQueryToTravel(payload)
        await this.getAgencySurveyQueries()
        await this.getAgencyTravelsOpinionSurveies(vm.listOpinionSurveyQuery.travelID)

        Message({
          message: '意見調查表複製完成',
          type: 'success',
          duration: 5 * 1000,
        })
        this.listLoading = false
      }
    },
    async getAgencySurveyQueries() {
      let vm = this
      let payload = {
        agencyCode: vm.$store.getters.userInfo.agencyCode
          ? vm.$store.getters.userInfo.agencyCode
          : null,
        travelID: this.listOpinionSurveyQuery.travelID,
      }

      vm.onGetAgencySurveyQueriesLoading = true
      let resp = await getAgencyTravelOpinionSurveyOptions(payload)
      vm.agencySurveyQueryOptions = resp.data
      vm.onGetAgencySurveyQueriesLoading = false
    },
    async triggerDefault(q) {
      let vm = this
      let agencyCode = vm.$store.getters.userInfo.agencyCode
        ? vm.$store.getters.userInfo.agencyCode
        : null

      if (!agencyCode) {
        alert(`未取得旅行社代碼。`)
        return
      }

      let payload = {
        qID: q.id,
        agencyCode,
      }
      this.listLoading = true

      let resp = await setAgencyOpinionSurveyDefault(payload)
      await this.getAgencyOpinionSurvey()

      Message({
        message: '預設意見調查表設定完成',
        type: 'success',
        duration: 5 * 1000,
      })
    },
    async getAgencyOpinionSurvey() {
      let vm = this
      let agencyCode = vm.$store.getters.userInfo.agencyCode
        ? vm.$store.getters.userInfo.agencyCode
        : null
      this.agencyListQuery.kind = null
      this.agencyListQuery.agencyCode = agencyCode
      this.listLoading = true
      let resp = await getAgencyOpinionSurvey(this.agencyListQuery)
      this.agencyOpinionSurveies = resp.data.data
      this.agencyTotal = resp.data.total
      this.listLoading = false
    },
    addData() {
      let vm = this
      let emptyData = {
        id: null,
        travelID: null,
        kind: 1,
        title: '',
        agencyCode: vm.$store.getters.userInfo.agencyCode
          ? vm.$store.getters.userInfo.agencyCode
          : null,
        isDefault: false,
        topicList: [],
      }
      this.opinionSurveyTopics = emptyData
      this.travelDefaultSelected = []
      this.dialogSurveyQueryTopicVisible = true
    },
    async getAnReply(row) {
      let vm = this
      let travelID = vm.travelID
      let uID = [row.userID]
      let qid = vm.questionnaireID
      let resp = await vm.getTravelsOpinionSurveyReplyDetails(travelID, qid, uID)
    },
    async saveTravelsOpinionSurveySetting() {
      let vm = this
      if (confirm(`確定要儲存意見調查?`)) {
        if (!this.opinionSurveyTopics.title) {
          alert(`請輸入表單標題`)
          return
        }
        if (this.opinionSurveyTopics.topicList.length == 0) {
          alert(`請至少輸入一個問題選項`)
          return
        }
        this.dialogLoading = true

        try {
          if (!this.opinionSurveyTopics.agencyCode) {
            this.opinionSurveyTopics.agencyCode = vm.$store.getters.userInfo.agencyCode
              ? vm.$store.getters.userInfo.agencyCode
              : null
          }
          const formatSortSelected =
            this.travelDefaultSelected.length > 0
              ? this.travelDefaultSelected.map(item => {
                  item.sort = this.opinionSurveyTopics.topicList.length + 1
                  return item
                })
              : []
          const newArr = this.opinionSurveyTopics.topicList.concat(formatSortSelected)
          const params = cloneDeep(this.opinionSurveyTopics)
          params.topicList = newArr
          console.log('opinionSurveyTopics', this.opinionSurveyTopics)
          let resp = await saveTravelsOpinionSurveySetting(params)
          // let resp = await saveTravelsOpinionSurveySetting(
          //   this.opinionSurveyTopics
          // );
          if (vm.dialogSurveyQueryVisible) {
            vm.dialogSurveyQueryVisible = false
            await this.getAgencyTravelsOpinionSurveies(vm.listOpinionSurveyQuery.travelID)
          }

          await this.getAgencyOpinionSurvey()
          await this.getAgencyTravelsAndOtherInformation()

          this.dialogLoading = false
          this.dialogSurveyQueryTopicVisible = false
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } catch (error) {
          this.dialogLoading = false
        }
      }
    },
    deleteTopic(index) {
      if (confirm(`確定刪除第${index + 1}題?`)) {
        this.opinionSurveyTopics.topicList.splice(index, 1)
      }
    },
    addTopic() {
      let vm = this
      let type = vm.newTopicData.newTopicOption
      let topic
      let sort = vm.opinionSurveyTopics.topicList.length + 1
      let options = [
        {
          optionID: null,
          optionDescription: '非常滿意',
          ansPoint: 5,
          sort: 1,
        },
        {
          optionID: null,
          optionDescription: '滿意',
          ansPoint: 4,
          sort: 2,
        },
        {
          optionID: null,
          optionDescription: '普通',
          ansPoint: 3,
          sort: 3,
        },
        {
          optionID: null,
          optionDescription: '不太滿意',
          ansPoint: 2,
          sort: 4,
        },
        {
          optionID: null,
          optionDescription: '非常不滿意',
          ansPoint: 1,
          sort: 5,
        },
      ]

      topic = {
        required: vm.newTopicData.required,
        isDefault: false,
        topicID: null,
        hasAns: false,
        topicDescription: vm.newTopicData.topicDescription,
        topicType: type,
        sort: sort,
        options: options,
        topicCustomAnswer: 0,
        topicGroup: 1,
      }

      switch (type) {
        case 1:
          topic.options = options
          break
        case 2:
          topic.options = []
          break
        default:
          break
      }
      vm.opinionSurveyTopics.topicList.push(topic)
    },
    async getTravelsOpinionSurveyTopic(id) {
      this.listLoading = true
      let resp = await getTravelsOpinionSurveyTopic({ id })
      this.listLoading = false
      this.travelDefaultSelected = []
      this.opinionSurveyTopics = resp.data
      this.defaultTopicGroup = this.opinionSurveyTopics.kind
      this.dialogSurveyQueryTopicVisible = true
      // setTimeout(() => {
      //   dropInit();
      // }, 500);
    },
    async getAgencyTravelsOpinionSurveies(travelID) {
      this.listOpinionSurveyQuery.travelID = travelID
      this.travelID = travelID
      this.listLoading = true
      let resp = await getAgencyTravelsOpinionSurveies(this.listOpinionSurveyQuery)
      this.opinionSurveies = resp.data.data
      this.listLoading = false
      this.dialogSurveyQueryVisible = true
    },
    async getAgencyTravelsAndOtherInformation() {
      this.listLoading = true
      let resp = await getAgencyTravelsAndOtherInformation(this.listQuery)
      this.list = resp.data.data
      this.total = resp.data.total
      this.averageAppSatisfactionPoint = resp.data.averageAppSatisfactionPoint || 0.0
      this.averageAppSatisfactionPointCount = resp.data.averageAppSatisfactionPointCount || 0
      this.listLoading = false
    },
    async confirmTravelsOpinionSurveyByOpinionSurveyID(qID) {
      this.questionnaireID = qID
      this.listLoading = true
      let resp = await confirmTravelsOpinionSurveyByOpinionSurveyID({
        ID: qID,
      })
      this.travelersReply = resp.data
      this.listLoading = false
      this.dialogVisible = true
    },
    async getTravelsOpinionSurveyReplyAllDetails(travelID) {
      this.travelID = travelID
      this.listLoading = true
      let resp = await getTravelsOpinionSurveyReplyAllDetails({ travelID })
      this.opinionSurveyPdfTopics = resp.data
      if (resp.data.length > 0) {
        this.dialogSurveyUserAnsStatisticsVisible = true
      } else {
        alert(`尚未建立意見調查表至旅遊團。`)
      }
      this.listLoading = false
    },
    async getPdf(travelID, travelName) {
      this.currentDlPdfIDs.push(travelID)
      this.pdfButtonLoading = true

      let chk = await getTravelsOpinionSurveyPdfBeforeCheck({ travelID })
      if (chk.success && !chk.data) {
        alert(`尚未建立意見調查表至旅遊團。`)
        this.pdfButtonLoading = false
        return
      }

      const url = `/TravelSettings/getTravelsOpinionSurveyReplyDetailsAllToPdf`

      try {
        let response = await request({
          url: url,
          method: 'get',
          params: { travelID },
          headers: {
            'Content-Type': 'application/octet-stream',
          },
          responseType: 'blob',
        })
        this.pdfButtonLoading = false
        const a = document.createElement('a')
        const u = window.URL.createObjectURL(response)
        a.href = u
        a.download = `${travelName}_意見調查表.pdf`
        a.click()

        this.currentDlPdfIDs = this.currentDlPdfIDs.filter(function (value, index, arr) {
          return value != travelID
        })

        this.$notify({
          title: '成功',
          message: '意見調查表PDF處理完成',
          type: 'success',
        })
      } catch (error) {
        console.log('error', error)
        this.pdfButtonLoading = false
      }

      // let resp = await getTravelsOpinionSurveyReplyDetailsAllToPdf({
      //   travelID,
      // });
      // console.log(resp);
      // this.opinionSurveyPdfTopics = resp.data;
      // this.dialogSurveyUserAnsStatisticsVisible = true;
      // this.listLoading = false;
    },
    async getExcel(travelID, travelName) {
      this.currentDlExcelIDs.push(travelID)
      this.pdfButtonLoading = true

      let chk = await getTravelsOpinionSurveyPdfBeforeCheck({ travelID })
      if (chk.success && !chk.data) {
        alert(`尚未建立意見調查表至旅遊團。`)
        this.pdfButtonLoading = false
        return
      }

      const url = `/TravelSettings/getTravelsOpinionSurveyReplyDetailsAllToExcel`

      try {
        let response = await request({
          url: url,
          method: 'get',
          params: { travelID },
          headers: {
            'Content-Type': 'application/octet-stream',
          },
          responseType: 'blob',
        })
        this.pdfButtonLoading = false
        const a = document.createElement('a')
        const u = window.URL.createObjectURL(response)
        a.href = u
        a.download = `${travelName}_意見調查表.xlsx`
        a.click()

        this.currentDlExcelIDs = this.currentDlExcelIDs.filter(function (value, index, arr) {
          return value != travelID
        })

        this.$notify({
          title: '成功',
          message: '意見調查表PDF處理完成',
          type: 'success',
        })
      } catch (error) {
        console.log('error', error)
        this.pdfButtonLoading = false
      }
    },
    // async screenshot(createImage) {
    //   // document.getElementById("seatDiv").style.width = "500px";
    //   // document.getElementById("leftContainer").style.width = "500px";

    //   //   let option = {
    //   //     x: 190,
    //   //     y: 20,
    //   //     width: 600,
    //   //     height: 1000,
    //   //   };
    //   debugger;
    //   var doc = new jsPDF();

    //   // html2canvas(document.body, {
    //   //   onrendered: function (canvas) {
    //   //     var image = canvas.toDataURL("image/png");
    //   //     doc.addImage(image, "JPEG", 0, 0, canvas.width, canvas.height);
    //   //     doc.save("test.pdf");
    //   //   },
    //   // });

    //   let canvas = await html2canvas(this.$refs.capture);
    //   let link = document.createElement("a");
    //   // link.href = canvas.toDataURL();
    //   let image = canvas.toDataURL();
    //   console.log(canvas.width);
    //   console.log(canvas.height);
    //   doc.addImage(image, "JPEG", 0, 0, canvas.width, canvas.height);
    //   doc.save("test.pdf");

    //   // this.imageUrl = canvas
    //   //   .toDataURL()
    //   //   .replace("data:", "")
    //   //   .replace(/^.+,/, "");

    //   // if (createImage) {
    //   //   link.setAttribute("download", "圖片canvas.png");
    //   //   link.style.display = "none";
    //   //   document.body.appendChild(link);
    //   //   link.click();
    //   // }
    // },
    async getTravelsOpinionSurveyReplyDetails(travelID, qID, userIDs) {
      this.travelID = travelID
      this.listLoading = true
      let resp = await getTravelsOpinionSurveyReplyDetails({
        travelID,
        qID,
        userIDs,
      })
      if (resp.data.length == 0) {
        alert(`尚未回覆`)
        this.listLoading = false
        return
      } else {
        this.ansSurveyTopics = resp.data[0]
        this.dialogSurveyQueryUserAnsVisible = true
        this.listLoading = false
        // this.dialogVisible = true;
      }
    },
    editData(row) {},
    saveData() {
      let vm = this
      vm.dialogLoading = true
      // saveCouponCategory().then((response) => {
      // vm.dialogLoading = false;
      //  Message({
      //               message: "資料處理完成",
      //               type: "success",
      //               duration: 5 * 1000,
      //             });

      // });
    },
    async getList() {
      this.listLoading = true
      this.listLoading = false
      // await getMembers(this.listQuery).then((response) => {
      //   this.list = response.data.data;
      //   this.total = response.data.total;
      //   this.listLoading = false;
      // });
    },
    // 變更選擇旅客預設題目
    handleKindChange(val) {
      if (val != 1) {
        this.travelDefaultSelected = []
      }
    },
    async exportAnalysisTableToPDF() {
      const element = this.$refs.analysisTableRef.$el
      if (!element) return

      this.isExportLoading = true

      const container = element.cloneNode(true)

      // 將 Clone 的 DOM 放在螢幕外面（避免影響畫面，但又能讓 html2canvas 抓取到樣式與寬度）
      // 注意：寬度要設定與原容器一致，否則 Element-UI 表格排版可能會跑版
      container.style.position = 'absolute'
      container.style.left = '-9999px'
      container.style.top = '-9999px'
      container.style.width = `${element.clientWidth}px`
      container.style.backgroundColor = '#ffffff'

      document.body.appendChild(container)

      // 建立 PDF 專用標題 DOM 節點
      const titleNode = document.createElement('h2')
      titleNode.innerText = `${this.currentSatisfactionAnalysis.title} 滿意度表格分析`
      titleNode.style.textAlign = 'center'
      titleNode.style.fontSize = '22px'
      titleNode.style.fontWeight = 'bold'
      titleNode.style.padding = '10px 20px 20px 0'
      titleNode.style.margin = '0'
      titleNode.style.backgroundColor = '#ffffff'

      container.insertBefore(titleNode, container.firstChild)

      try {
        const canvas = await html2canvas(container, {
          scale: 2, // 提高畫質解析度
          useCORS: true,
          logging: false,
        })

        // --- 邊距設定 (單位: pt) ---
        const leftMargin = 20 // 左右邊距 (可自由調整 15~30)
        const topMargin = 20 // 上邊距

        const pdfWidth = 595.28 // A4 寬度
        const pdfHeight = 841.89 // A4 高度

        // 計算扣除左右邊距後的內容實際寬度
        const imgWidth = pdfWidth - leftMargin * 2
        // 依照內容實際寬度等比例縮放高度
        const imgHeight = (imgWidth / canvas.width) * canvas.height

        const pageData = canvas.toDataURL('image/jpeg', 1.0)
        const pdf = new jsPDF('p', 'pt', 'a4')

        let leftHeight = imgHeight
        let position = topMargin

        // 判斷單頁或多頁處理
        if (leftHeight < pdfHeight - topMargin * 2) {
          pdf.addImage(pageData, 'JPEG', leftMargin, topMargin, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', leftMargin, position, imgWidth, imgHeight)
            leftHeight -= pdfHeight
            position -= pdfHeight
            if (leftHeight > 0) {
              pdf.addPage()
            }
          }
        }

        const fileName = `${this.currentSatisfactionAnalysis.title}_滿意度分析報告.pdf`
        pdf.save(fileName)
      } catch (error) {
        console.error('PDF 匯出失敗:', error)
        this.$message.error('匯出 PDF 失敗，請稍後再試')
      } finally {
        // 移除 Clone DOM
        if (container && container.parentNode) {
          container.parentNode.removeChild(container)
        }
        this.isExportLoading = false
      }
    },
    async exportAnalysisHistogramCahtsToPDF() {
      const element = this.$refs.analysisHistogramCahtsRef
      if (!element) return

      this.isExportLoading = true

      const container = element.cloneNode(true)

      const srcCanvases = element.querySelectorAll('canvas')
      const clonedCanvases = container.querySelectorAll('canvas')

      srcCanvases.forEach((srcCanvas, i) => {
        const destCanvas = clonedCanvases[i]
        if (destCanvas) {
          destCanvas.width = srcCanvas.width
          destCanvas.height = srcCanvas.height
          const destCtx = destCanvas.getContext('2d')
          if (destCtx) {
            destCtx.drawImage(srcCanvas, 0, 0)
          }
        }
      })

      // 將 Clone 的 DOM 放在螢幕外面（避免影響畫面，但又能讓 html2canvas 抓取到樣式與寬度）
      // 注意：寬度要設定與原容器一致，否則 Element-UI 表格排版可能會跑版
      container.style.position = 'absolute'
      container.style.left = '-9999px'
      container.style.top = '-9999px'
      container.style.width = `${element.clientWidth}px`
      container.style.backgroundColor = '#ffffff'

      document.body.appendChild(container)

      // 建立 PDF 專用標題 DOM 節點
      const titleNode = document.createElement('h2')
      titleNode.innerText = `${this.currentSatisfactionAnalysis.title} 滿意度圖表分析(百分比)`
      titleNode.style.textAlign = 'center'
      titleNode.style.fontSize = '22px'
      titleNode.style.fontWeight = 'bold'
      titleNode.style.padding = '10px 0px 40px 0'
      titleNode.style.margin = '0'
      titleNode.style.backgroundColor = '#ffffff'

      container.insertBefore(titleNode, container.firstChild)

      try {
        const canvas = await html2canvas(container, {
          scale: 2, // 提高畫質解析度
          useCORS: true,
          logging: false,
        })

        // --- 邊距設定 (單位: pt) ---
        const leftMargin = 20 // 左右邊距 (可自由調整 15~30)
        const topMargin = 20 // 上邊距

        const pdfWidth = 595.28 // A4 寬度
        const pdfHeight = 841.89 // A4 高度

        // 計算扣除左右邊距後的內容實際寬度
        const imgWidth = pdfWidth - leftMargin * 2
        // 依照內容實際寬度等比例縮放高度
        const imgHeight = (imgWidth / canvas.width) * canvas.height

        const pageData = canvas.toDataURL('image/jpeg', 1.0)
        const pdf = new jsPDF('p', 'pt', 'a4')

        let leftHeight = imgHeight
        let position = topMargin

        // 判斷單頁或多頁處理
        if (leftHeight < pdfHeight - topMargin * 2) {
          pdf.addImage(pageData, 'JPEG', leftMargin, topMargin, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', leftMargin, position, imgWidth, imgHeight)
            leftHeight -= pdfHeight
            position -= pdfHeight
            if (leftHeight > 0) {
              pdf.addPage()
            }
          }
        }

        const fileName = `${this.currentSatisfactionAnalysis.title}_滿意度圖表分析(百分比)報告.pdf`
        pdf.save(fileName)
      } catch (error) {
        console.error('PDF 匯出失敗:', error)
        this.$message.error('匯出 PDF 失敗，請稍後再試')
      } finally {
        // 移除 Clone DOM
        if (container && container.parentNode) {
          container.parentNode.removeChild(container)
        }
        this.isExportLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding: 15px !important;
}

.el-input.is-disabled .el-input__inner {
  color: blue;
}

.ans-text .el-input__inner {
  color: red !important;
  font-size: 16px;
  font-weight: bold;
}

.new-topic-control {
  position: relative;
  z-index: 9999;
  background-color: white;
  border: solid 2px #ccc;
  padding: 5px;
  border-radius: 12px;
  top: 3%;
  right: 20px;
}

#ansPdfModel .iconSize {
  font-size: 2em;
}

.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;

  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;

    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}

.page-component__scroll {
  height: 100%;
  min-height: 500px;
}

.page-component__scroll .el-scrollbar__wrap {
  overflow-x: auto;
}

.el-tabs--card {
  height: calc(100vh - 200px);
  /* overflow-y: auto; */
}

.el-tab-pane {
  height: calc(100vh - 200px);
  /* overflow-y: auto; */
}

.maintainCard .el-card__body {
  height: 100% !important;
}
</style>

<style scoped>
.dialog-header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 30px; /* 留出空間給預設的關閉按鈕 x */
}

.download-pdf-btn {
  margin-left: auto;
}
</style>
